<template>
  <div class="container box-center">
    <div id="recaptcha-container"></div>
    <div class="col-sm-12 text-center pb-4">
      <h3 class="text-center">{{ errormessage }}</h3>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6 pb-5 text-center" style="max-width: 449px">
        <div class="container pb-5">
          <img
            src="../assets/aamcartlogo.jpg"
            alt="Aamcart-logo"
            width="190px"
          />
        </div>
        <div class="container">
          <h2 class="header">Signin/ Signup</h2>
        </div>
        <div class="container">
          <p>Sign in to continue access</p>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 text-center pb-5" v-show="show">
        <h5 class="main-color pb-4">Signin / Signup</h5>
        <input
          type="text"
          v-model="phNo"
          class="form-custom"
          placeholder="Mobile Number"
          style="max-width: 419px"
        />
        <button
          class="custom-button mt-5"
          style="max-width: 419px"
          @click="sendOtp"
          v-if="!loading"
        >
          <span>Continue</span>&nbsp;
          <i class="fa fa-angle-right"></i>
        </button>
        <button
          class="custom-button mt-5"
          style="max-width: 419px"
          disabled
          v-if="loading"
        >
          <span>Loading</span>&nbsp;
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div class="col-sm-12 col-md-6 text-center pb-5" v-show="otpshow">
        <h5 class="pb-4">
          Please enter the OTP sent to
          <span class="main-color">{{ phNo }}</span>
        </h5>
        <input
          type="text"
          class="form-custom"
          v-model="otp"
          placeholder="Enter OTP"
          style="max-width: 419px"
        />
        <button
          class="custom-button mt-5"
          style="max-width: 419px"
          @click="verifyOtp"
          v-if="!loading"
        >
          <span>Continue</span>&nbsp;
          <i class="fa fa-angle-right "></i>
        </button>
        <button
          class="custom-button mt-5"
          style="max-width: 419px"
          disabled
          v-if="loading"
        >
          <span>Verifing OTP</span>&nbsp;
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        </button>
        <div class="pt-4">
          <span
            >Not received your code?
            <span class="main-color" role="button" @click="sendOtp"
              >Resend Code</span
            ></span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../modules/store";
import firebase from "firebase";
import { mapGetters } from "vuex";
import { login, addCustomerIntoDb } from "../modules/auth";
import constants from "../modules/constants";
import router from "../modules/router";

export default {
  data: () => {
    return {
      loading: false,
      errorType: "",
      errormessage: "",
      phNo: "",
      appVerifier: "",
      otp: "",
      customer: {
        name: "",
        number: "",
        email: "",
        defaultAddress: "",
        image: ""
      },
      resetEmail: "",
      show: true,
      otpshow: false,
      success: null,
      reset: false,
      resetButtonText: constants.actions.send_reset,
      navigateAfterLogin: false,
      navigateTimeout: null
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  beforeDestroy() {
    clearTimeout(this.navigateTimeout);
  },
  mounted() {
    this.check_login();
  },
  methods: {
    loginAction() {
      if (!(this.login.email && this.login.password)) {
        this.$root.toast(constants.errors.fill_fields);
        return;
      }
      if (
        this.login.email.trim().length === 0 ||
        this.login.password.trim().length === 0
      ) {
        this.$root.toast(constants.errors.fill_fields);
        return;
      }
      this.show = false;
      login(this.login.email, this.login.password)
        .then(user => {
          this.navigateAfterLogin = true;
          //set timeout for navigation
          this.navigateTimeout = setTimeout(() => {
            this.navigateAfterLogin = false;
          }, 10000);
          this.$root.toast(
            "Welcome back, " +
              (user.displayName.split(" ")[0] || user.displayName) +
              "!"
          );
          if (this.$route.params.type == "general") {
            this.redirect_to_genral();
          }
          if (this.$route.params.type == "subscription") {
            this.redirect_to_subscriptions();
          } else {
            // console.log("check");
            router.go(-1);
          }
          this.hideAction();
        })
        .catch(() => {
          this.$root.toast(constants.errors["auth/wrong-password"]);
        })
        .finally(() => {
          this.login.email = "";
          this.login.password = "";
          this.show = true;
        });
    },
    check_login() {
      if (this.user !== null) {
        router.push("/");
      }
    },
    sendOtp() {
      this.loading = true;
      this.errorType = "loading";
      this.errormessage = "Sending OTP";
      //   console.log(this.phNo);
      if (this.phNo.length !== 10) {
        this.errorType = "error";
        this.errormessage = "Invalid Phone Number";
        // setTimeout(() => {
        this.loading = false;
        // }, 5000);
      } else {
        //
        let countryCode = "+91"; //india
        let phoneNumber = countryCode + this.phNo;
        //
        let appVerifier = this.appVerifier;
        //
        firebase
          .auth()
          .signInWithPhoneNumber(phoneNumber, appVerifier)
          .then(confirmationResult => {
            window.confirmationResult = confirmationResult;
            this.show = false;
            this.otpshow = true;
          })
          .catch(error => {
            this.errorType = "error";
            this.errormessage = "Error! Code Not Sent Try Again";
            // setTimeout(() => {
            this.loading = false;
            // }, 500);
            console.log(error);
          })
          .finally(() => {
            this.errorType = "success";
            this.errormessage = "Verification Code Sent Successful";
            // setTimeout(() => {
            this.loading = false;
            // }, 500);
          });
      }
    },
    verifyOtp() {
      let customer = {
        number: "+91" + this.phNo
      };
      this.loading = true;
      this.errorType = "loading";
      this.errormessage = "Verifing Otp";
      let code = this.otp;
      window.confirmationResult
        .confirm(code)
        .then(function(result) {
          let user = result.user;
          addCustomerIntoDb(user.uid, customer)
            .then(() => {
              store.dispatch({
                type: "updateUser",
                user: user
              });
            })
            .finally(() => {
              router.push("/");
            });
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          this.errorType = "error";
          this.errormessage = "Wrong Otp Try Again";
          //   setTimeout(() => {
          this.loading = false;
          //   }, 3000);
        });
    },
    initReCaptcha() {
      setTimeout(() => {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
          "recaptcha-container",
          {
            size: "invisible",
            callback: function(response) {
              console.log(response);
              // reCAPTCHA solved, allow signInWithPhoneNumber.
              // ...
            },
            "expired-callback": function() {
              // Response expired. Ask user to solve reCAPTCHA again.
              // ...
            }
          }
        );
        //
        this.appVerifier = window.recaptchaVerifier;
      }, 500);
    }
  },
  created() {
    this.initReCaptcha();
  },
  watch: {
    user() {
      if (this.user != null) {
        this.check_login();
      }
    }
  }
};
</script>
<style>
.header {
  color: black;
  font-weight: bold;
}
.main-color {
  color: #f69325;
}
.form-custom {
  border: none;
  outline: none;
  border-bottom: 3px solid #dedede;
  padding: 5px 10px;
  width: 100%;
}
.custom-button {
  background: linear-gradient(270deg, #ff470bd0 0%, #f69325 100%);
  border: none;
  outline: none;
  padding: 8px 0;
  width: 100%;
  border-radius: 25px;
  color: white;
}
.box-center {
  padding-top: 16%;
}
</style>
